import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

export default function useApiStatus() {
	return useSwr(API_URL, fetcher)
}
